import { toast } from 'sonner'
import { useState, useEffect } from 'react'
import { fError } from '@/utils/format-error'
import axios, { endpoints } from '@/lib/axios'
import { useBoolean } from '@/hooks/use-boolean'
import { useParams } from '@/routes/hooks/use-params'
import LoadingSection from '@/components/loading-indicator/loading-section'

import type { Product } from '../product.types'

import ProductForm from '../product-form'

// Product category interface
interface ProductCategory {
  id: string
  name: string
  description?: string
  isActive: boolean
}

// ----------------------------------------------------------------------

export default function ProductFormView() {
  const params = useParams()
  const loading = useBoolean(true)
  const [product, setProduct] = useState<Product | undefined>(undefined)
  const [categories, setCategories] = useState<ProductCategory[]>([])
  const [categoriesLoading, setCategoriesLoading] = useState(true)
  const isEditMode = params.id !== undefined

  const fetchProduct = async () => {
    if (!isEditMode || !params.id) {
      loading.onFalse()
      return
    }

    try {
      loading.onTrue()
      const { data } = await axios.get<Product>(
        endpoints.products.detail(params.id),
      )
      setProduct(data)
    } catch (error) {
      toast.error(fError(error))
    } finally {
      loading.onFalse()
    }
  }

  const fetchCategories = async () => {
    try {
      setCategoriesLoading(true)
      const { data } = await axios.get(endpoints.productCategories.list)
      setCategories(data.items || data || [])
    } catch (error) {
      console.error('Error fetching categories:', error)
      toast.error('ไม่สามารถโหลดหมวดหมู่สินค้าได้')
    } finally {
      setCategoriesLoading(false)
    }
  }

  useEffect(() => {
    fetchProduct()
    fetchCategories()
  }, [params.id])

  return (
    <LoadingSection loading={loading.value || categoriesLoading}>
      <ProductForm
        product={product}
        mode={isEditMode ? 'edit' : 'create'}
        categories={categories}
      />
    </LoadingSection>
  )
}
